import {required} from '@vuelidate/validators';

const azureConnection = (t) => (
  {
    rows: [
      {
        blocks: [
          {
            fields: [
              {
                name: 'containerName',
                type: 'text',
                placeholder: t('settings.connections.containerName')
              },
              {
                name: 'accountName',
                type: 'text',
                placeholder: t('settings.connections.accountName')
              },
              {
                name: 'accountKey',
                type: 'text',
                placeholder: t('settings.connections.accountKey')
              },
            ]
          },
        ]
      }
    ],
    validations: {
      containerName: {
        required
      },
      accountName: {
        required
      },
      accountKey: {
        required
      },

    },
    errors: {
      containerName: {
        required: t('settings.connections.containerNameRequired'),
      },
      accountName: {
        required: t('settings.connections.accountNameRequired'),
      },
      accountKey: {
        required: t('settings.connections.accountKeyReqiured'),
      },
    }
  }
)


export {
  azureConnection,
}
